import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import CTAButton from '../../../CTAButton/CTAButton';

import {
  TXTWCL_Back_to_Cashier,
  TXTWCL_You_canXt_deposit_right_now,
  TXTWCL_You_can_view_and_change_your_l_ELL,
  TXTWCL_You_have_reached_your_self_imp_ELL
} from './DepositRestricted.messages.json';

interface Props {
  wizardError?: boolean;
  errorMessage?: string;
}

const DepositRestricted: React.FC<Props> = ({ wizardError, errorMessage }) => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  const { enqueue } = useDispatch<Dispatch>().modal;
  const depositLimitPath = useSelector(select.account.getDepositLimitPath);

  const openRestrictDepositLimit = (e: React.MouseEvent) => {
    e.preventDefault();
    isEmbedded
      ? window.starsweb?.app.execute('menu/requests/responsible-gaming/deposit-limit')
      : enqueue({ path: depositLimitPath });
  };

  return (
    <>
      <Translation tagName="h2" {...TXTWCL_You_canXt_deposit_right_now} />
      <p>
        {wizardError ? (
          errorMessage
        ) : (
          <>
            <Translation {...TXTWCL_You_have_reached_your_self_imp_ELL} />{' '}
            <Translation
              {...TXTWCL_You_can_view_and_change_your_l_ELL}
              values={{
                a: (msg: string) => <StarsLink onClick={openRestrictDepositLimit}>{msg}</StarsLink>
              }}
            />
          </>
        )}
      </p>

      <CTAButton type="button" alias="firstWalletHome" translation={TXTWCL_Back_to_Cashier} />
    </>
  );
};

export default DepositRestricted;
